import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { DocumentSelectModalComponent } from './document-select-modal.component';

@NgModule({
    declarations: [
        DocumentSelectModalComponent
    ],
    exports: [
        DocumentSelectModalComponent
    ],
    imports: [
        CommonModule,
        TableModule,
        SharedPipesModule
    ]
})
export class DocumentSelectModalModule {
}
